// extracted by mini-css-extract-plugin
export default {"root":"MessageActions_root__y6QEk"};